<template>
  <draggable :list="files" :options="drapConfig" class="container" @change="onChange">
    <transition-group tag="ul" :class="[
    'el-upload-list',
    'el-upload-list--' + listType,
    { 'is-disabled': disabled }
  ]" name="el-list">
      <li v-for="(file, index) in files" :class="['el-upload-list__item', 'is-' + file.status]" :key="index">
        <component :is="isVideo(file) ? 'video' : 'img'" class="el-upload-list__item-thumbnail mosaic-bg"
          v-if="file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(listType) > -1" :src="file.url"
          alt=""/>
        <a class="el-upload-list__item-name" @click="handleClick(file)">
          <i class="el-icon-document"></i>{{ file.name }}
        </a>
        <label class="el-upload-list__item-status-label">
          <i :class="{
    'el-icon-upload-success': true,
    'el-icon-circle-check': listType === 'text',
    'el-icon-check': ['picture-card', 'picture'].indexOf(listType) > -1
  }"></i>
        </label>
        <i class="el-icon-close" v-if="!disabled" @click="$emit('remove', file)"></i>
        <el-progress v-if="file.status === 'uploading'" :type="listType === 'picture-card' ? 'circle' : 'line'"
          :stroke-width="listType === 'picture-card' ? 6 : 2" :percentage="parsePercentage(file.percentage)">
        </el-progress>
        <el-tooltip :disabled="!file.errMsg" placement="top">
          <div v-html="file.errMsg" slot="content"></div>
          <span class="el-upload-list__item-actions" v-if="listType === 'picture-card'">
            <span class="el-upload-list__item-preview" v-if="handlePreview && listType === 'picture-card'"
              @click="handlePreview(file)">
              <i class="el-icon-view"></i>
            </span>
            <span v-if="!disabled" class="el-upload-list__item-delete" @click="$emit('remove', file)">
              <i class="el-icon-delete2"></i>
            </span>
          </span>
        </el-tooltip>
      </li>
    </transition-group>
  </draggable>
</template>
<script>
import Locale from '../../mixins/locale';
import ElProgress from '../../progress';
import draggable from 'vuedraggable';

export default {
  mixins: [Locale],

  components: { ElProgress, draggable },

  props: {
    files: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    handlePreview: Function,
    handleChange: Function,
    listType: String
  },
  data() {
    return {
      drapConfig: {
        group: 'description',
        animation: 200,
        ghostClass: 'ghost',
        draggable: '.el-upload-list__item',
        sort: true
      }
    }
  },
  methods: {
    onChange(e) {
      this.handleChange(e.moved.element, this.files)
      console.log('handleChange', e)
    },
    parsePercentage(val) {
      return parseInt(val, 10);
    },
    handleClick(file) {
      this.handlePreview && this.handlePreview(file);
    },
    isVideo(file) {
      if (file.info && file.info.type) {
        return file.info.type.includes('video')
      } else if(file.raw && file.raw.type) {
        return file.raw.type.includes('video')
      } else if(file.url) {
        return file.url.includes('.mp4')
      }
      return false
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../index.scss';

.container {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/QnUpload-1.vue?2c2eef39